import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
    utilityMode: boolean;
    highContrast: boolean;
    muteAudio: boolean;
    toggleUtilityMode: () => void;
    setMuteAudio: (mute: boolean) => void;
    setHighContrast: (high: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
    persist(
        (set) => ({
            utilityMode: false,
            highContrast: false,
            muteAudio: false,
            toggleUtilityMode: () => set((state) => ({
                utilityMode: !state.utilityMode,
                // Enabling utility mode usually implies muting audio and high contrast for these users
                muteAudio: !state.utilityMode ? true : state.muteAudio,
                highContrast: !state.utilityMode ? true : state.highContrast
            })),
            setMuteAudio: (muteAudio) => set({ muteAudio }),
            setHighContrast: (highContrast) => set({ highContrast }),
        }),
        {
            name: 'alpha-settings-storage',
        }
    )
);
